/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { REQUEST_STATUS } from "@/ts/enums/RequestStatus";
import { getStudentAssignmentDetailsThunk } from "../thunks";
import { AssignmentInterface } from "@/ts/interfaces/MarkingPortal/AssignmentInterface";

interface AssignmentDetailsState {
    status: REQUEST_STATUS;
    error: string | null;
    data: AssignmentInterface | null;
    highestSubmission: any | null;
}

const initialState: AssignmentDetailsState = {
    status: REQUEST_STATUS.IDLE,
    error: null,
    data: null,
    highestSubmission: null,
};

const assignmentDetailsSlice = createSlice({
    name: "reporting/assignmentDetails",
    initialState,
    reducers: {
        resetAssignmentDetailsState: () => initialState,
        clearAssignmentDetails: state => {
            state.status = REQUEST_STATUS.IDLE;
            state.error = null;
            state.data = null;
            state.highestSubmission = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getStudentAssignmentDetailsThunk.pending, state => {
                state.status = REQUEST_STATUS.PENDING;
                state.error = null;
            })
            .addCase(
                getStudentAssignmentDetailsThunk.fulfilled,
                (
                    state,
                    action: PayloadAction<{ data: AssignmentInterface; highestSubmission: any | null }>
                ) => {
                    state.status = REQUEST_STATUS.SUCCESS;
                    state.data = action.payload.data;
                    state.highestSubmission = action.payload.highestSubmission;
                }
            )
            .addCase(getStudentAssignmentDetailsThunk.rejected, (state, action) => {
                state.status = REQUEST_STATUS.ERROR;
                state.error = (action.payload as string) ?? action.error.message ?? "Unknown error";
                state.data = null;
                state.highestSubmission = null;
            });
    },
});

export const { resetAssignmentDetailsState, clearAssignmentDetails } =
    assignmentDetailsSlice.actions;

export default assignmentDetailsSlice.reducer;
